module.exports = __webpack_public_path__ + "media/images/e-bilet/arrow-28b4012b0fbb7b063eb63c4a23b4ded6.png";